
import { CharacterFeatureSource } from "@dndModels/character_feature_source/CharacterFeatureSource";
import { 
  CharacterFeatureBase,
  CharacterSpellbook,
  Subclass,
  BonusSpells,
} from "@dndModels";

export class CharacterSubclass extends CharacterFeatureSource {
  source: Subclass | null = null;
  position = 0;
  game_class_id = "";
  // Spellcasting
  spellcasting_ability = "";
  spell_dc = 0;
  spell_attack = 0;
  spell_table = "";
  spell_level_max = 0;
  spellcasting_level = 0; // Full, Half, Third, etc
  spell_list_id = "";
  spell_ids: string[] = [];
  cantrip_ids: string[] = [];
  knowledge_type = ""; // Prepared, Known, Spellbook
  // These can be increased through other features.
  cantrips_max = 0;
  // base_spell_count: number;
  // spell_count_per_level: number;
  // extra_prepared_from_ability: string; // This increases the number of spells Prepared/Known
  spells_prepared_max = 0; // This is calculated from the two above
  // These can be granted through other features
  ritual_casting = false;
  spellcasting_focus = "";
  // These are only from other features
  spellbook: CharacterSpellbook | null = null;
  bonus_spells: BonusSpells[] = [];

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      if (this.source_id === "" && obj.game_class_id) {
        this.source_id = obj.game_class_id;
      }
      if (this.char_feature_bases.length === 0 && obj.features && obj.features.length > 0) {
        obj.features.forEach((o: any) => {
          const fb = new CharacterFeatureBase(o);
          fb.source_id = this.source_id;
          fb.source_name = this.name;
          fb.source_type = "subclass";
          // fb.root_id = this.source_id;
          // fb.root_name = this.name;
          // fb.root_type = "subclass";
          fb.ancestries = [...this.ancestries.map(o => { return {...o}; })];
          this.char_feature_bases.push(fb);
        });
      }
      this.spellbook = obj && obj.spellbook ? new CharacterSpellbook(obj.spellbook) : null;
    }
  }

  toDBObj(): any {
    const feature_source_obj = super.toDBObj();
    return {
      ...feature_source_obj,
      spellbook: this.spellbook ? this.spellbook.toDBObj() : null
    };
  }

  clone(drop_ids = false): CharacterSubclass {
    const clone = new CharacterSubclass();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: CharacterSubclass, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.position = copyMe.position;
    this.source = copyMe.source;
  }
}